var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('charts',{ref:"bar",attrs:{"id":"test","options":_vm.barOption,"height":"500px"}}),_c('charts',{attrs:{"id":"test1","options":_vm.pieOption,"height":"500px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }